import BootstrapUtil from '../bootstrap-util';
import TimedBiddingManager from '../js/timed-bidding/timed-bidding-manager';
import MarketguardMessageManager from '../js/message/marketguard-message-manager';
import DepositMessageManager from '../js/message/deposit-message-manager';
import DialogManager from '../js/dialog/dialog-manager';
import SnackbarMessageManager from "../js/message/snackbar-message-manager";

const reactComponentMap = {
    'TimedBiddingManager': TimedBiddingManager,
    'MarketguardMessageManager': MarketguardMessageManager,
    'DepositMessageManager': DepositMessageManager,
    'DialogManager': DialogManager,
    'SnackbarMessageManager': SnackbarMessageManager
};

BootstrapUtil.bootstrapEntrypoint(reactComponentMap);